import React from 'react';
import NavbarDropdown from './NavbarDropdown';
import {
  appRoutes,
  pagesRoutes,
  modulesRoutes,
  DashRoutes,
  // documentationRoutes
} from 'routes/siteMaps';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { flatRoutes } from 'helpers/utils';
import NavbarDropdownApp from './NavbarDropdownApp';
import NavbarDropdownPages from './NavbarDropdownPages';
import NavbarDropdownModules from './NavbarDropdownModules';
import { useAppContext } from 'providers/AppProvider';
import { useIsK8s } from '../../../hooks/useConfig';
import { isDemoMode } from '../../../data/demoMockData';


const NavbarTopDropDownMenus = (route) => {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig
  } = useAppContext();

  const isK8s = useIsK8s();

  const handleDropdownItemClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  // 대시보드 메뉴의 isEnabled 상태 확인
  const dashboardMenu = DashRoutes.children.find(child => child.name === '대시보드');
  const isDashboardEnabled = dashboardMenu?.isEnabled !== false;

  return (
    <>
      {/* <Link to="/">dashboard</Link> */}
      {/* hrefLink를 만들어줘서 NavbarDropdown에 같이보냄, NavbarDropdown이 링크 만들어줌 */}
      {/* 총괄대시보드: SaaS에서만 표시 */}
      {!isK8s ? (
        isDashboardEnabled ? (
          <NavbarDropdown title="총괄대시보드" hrefLink='/dashboard/crm'>
            {/* {dashboardRoutes.children[0].children.map(route => (
            <Dropdown.Item
              key={route.name}
              as={Link}
              className={route.active ? 'link-600' : 'text-500'}
              to={route.to}
            // onClick={handleDropdownItemClick}
            >
              {route.name}
            </Dropdown.Item>
          ))} */}
          </NavbarDropdown>
        ) : (
          <span
            className="nav-link text-secondary text-decoration-line-through fw-semibold"
            style={{ cursor: 'not-allowed' }}
          >
            총괄대시보드
          </span>
        )
      ) : null}


      <NavbarDropdown title="관리자계정" hrefLink='/safedb/SA/adminAccount'>
        {/* <NavbarDropdownApp items={appRoutes.children} /> */}
      </NavbarDropdown>

      <NavbarDropdown title="관리정책" hrefLink='/safedb/SA/policyManager'>
        {/* <NavbarDropdownPages items={pagesRoutes.children} /> */}
      </NavbarDropdown>
      <NavbarDropdown title="관리활동로그" hrefLink='/safedb/SA/logAdmin'>
        {/* <NavbarDropdownModules items={paths.starter} /> */}

      </NavbarDropdown>
      {/* <NavbarDropdown title="청구관리" hrefLink='/pages/starter'> */}
      {/* <NavbarDropdownModules items={modulesRoutes.children} /> */}
      {/* </NavbarDropdown> */}
      <NavbarDropdown title="고객사관리" hrefLink='/safedb/SA/adminSites'>
        {/* <NavbarDropdownModules items={modulesRoutes.children} /> */}
      </NavbarDropdown>

      {/* 요금정책관리: SaaS, k8s 둘 다 표시 */}
      <NavbarDropdown title="요금정책관리" hrefLink='/safedb/SA/pricingPolicy'>
        {/* <NavbarDropdownModules items={modulesRoutes.children} /> */}
      </NavbarDropdown>

      {/* API 테스트: SaaS + 데모 모드일 때만 표시 */}
      {!isK8s && isDemoMode() && (
        <NavbarDropdown title="API 테스트" hrefLink='/safedb/SA/apiTest'>
        </NavbarDropdown>
      )}

      {/* <NavbarDropdown title="documentation">
        {flatRoutes(documentationRoutes.children).map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown> */}

    </>
  );
};

export default NavbarTopDropDownMenus;
